import type { AssetInfoConditionRatingProps } from "./asset-info-condition-rating.type";

import { useTranslation } from "react-i18next";

import { useReferentialConditionRatings } from "@/entities/referential/referential-condition-ratings";
import { AssetConditionRatingTag } from "@/modules/asset/asset-condition-rating-tag";
import { FlexContainerText } from "@/modules/flex-container";

export const AssetInfoConditionRating = ({
  asset,
}: AssetInfoConditionRatingProps) => {
  const { t } = useTranslation();
  const { isLoading } = useReferentialConditionRatings();

  return (
    <FlexContainerText
      label={t("asset:form.conditionRating.label")}
      value={<AssetConditionRatingTag asset={asset} size="large" />}
      isLoading={isLoading}
    />
  );
};
